export const AREA_MIN = 0
export const AREA_MAX = 1200

export const PRICE_MIN = 0
export const PRICE_MAX = 999999

// ACTION TYPES
export const CHANGE_TAB = 'CHANGE_TAB'
export const FETCH_LOTS = 'FETCH_LOTS'
export const FETCH_HOUSES = 'FETCH_HOUSES'
export const FILTER_LOTS = 'FILTER_LOTS'
export const FILTER_LOTS_CLEAR = 'FILTER_LOTS_CLEAR'
export const FETCH_STAGES = 'FETCH_STAGES'
export const FETCH_POINTS = 'FETCH_POINTS'
export const FETCH_BUILDERS = 'FETCH_BUILDERS'
export const FETCH_POINTS_CATEGORY = 'FETCH_POINTS_CATEGORY'
export const FETCH_FAVOURITES = 'FETCH_FAVOURITES'
export const ADD_LOT_TO_FAVOURITES = 'ADD_LOT_TO_FAVOURITES'
export const ADD_PACKAGE_TO_FAVOURITES = 'ADD_PACKAGE_TO_FAVOURITES'

export const SORT_HOUSES = 'SORT_HOUSES'
export const SORT_LOTS = 'SORT_LOTS'

export const FILTER_HOUSES = 'FILTER_HOUSES'
export const FILTER_HOUSES_CLEAR = 'FILTER_HOUSES_CLEAR'
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'
export const EMAIL_ERROR = 'EMAIL_ERROR'
export const EMAIL_ERROR_RESET = 'EMAIL_ERROR_RESET'

export const SET_SELECTED_STAGE = 'SET_SELECTED_STAGE'
export const SHOW_LOT_POPUP = 'SHOW_LOT_POPUP'
export const HIDE_LOT_POPUP = 'HIDE_LOT_POPUP'
export const SHOW_POINT_POPUP = 'SHOW_POINT_POPUP'
export const SET_POINTS_INITIALIZED = 'SET_POINTS_INITIALIZED'
export const SET_ONSITE_POINTS_INITIALIZED = 'SET_ONSITE_POINTS_INITIALIZED'
export const SET_SELECTED_POI = 'SET_SELECTED_POI'
export const SET_CACHED_PACKAGES = 'SET_CACHED_PACKAGES'
export const FETCH_PROJECT_DATA = 'FETCH_PROJECT_DATA'
export const SET_MAP_POPUP = 'SET_MAP_POPUP'
export const SET_MAP_PADDING_REFS = 'SET_MAP_PADDING_REFS'
export const SET_PDF_URL = 'SET_PDF_URL'

export const SET_AGREEMENT_MODAL_TYPE = 'SET_AGREEMENT_MODAL_TYPE'
export const SIGNIN_SALES = 'SIGNIN_SALES'
export const SIGNOUT_SALES = 'SIGNOUT_SALES'
export const SIGNIN_SALES_FAILED = 'SIGNIN_SALES_FAILED'
export const TOGGLE_CONTENT_VISIBILITY = 'TOGGLE_CONTENT_VISIBILITY'
export const SET_CONTENT_VISIBILITY = 'SET_CONTENT_VISIBILITY'
export const SET_TOGGLE_BUTTON_VISIBILITY = 'SET_TOGGLE_BUTTON_VISIBILITY'
export const SET_MAP_SCALE_VISIBILITY = 'SET_MAP_SCALE_VISIBILITY'

export const DISPLAY_ROUTE_TO_POINT = 'DISPLAY_ROUTE_TO_POINT';
export const HIDE_ROUTE_TO_POINT = 'HIDE_ROUTE_TO_POINT';
export const SET_DIRECTIONS = 'SET_DIRECTIONS'

// MAP ACTION TYPES
export const MAP_SET = 'MAP_SET'
